module.exports = function LinkResolver(doc) {
  // Pretty URLs for known types
  if (doc.type === 'page') return `/${doc.lang}/${doc.uid}/`
  // Fallback for other types, in case new custom types get created
  return '/doc/' + doc.id
}
